import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} arrow />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(33, 33, 33, 0.95)',
        color: '#fff',
        fontSize: '0.813rem',
        padding: '10px 14px',
        borderRadius: '8px',
        maxWidth: 280,
        lineHeight: 1.5,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: 'rgba(33, 33, 33, 0.95)',
    },
}));
